import { api } from '../api';

const reviewsPath = '/reviews';

export const getReviews = data =>
  api.post(`${reviewsPath}/filter?page=${data.page}`, data);

export const saveReview = data => api.post(`${reviewsPath}`, data);
